import { Stack } from '@superdispatch/ui';
import { formatCurrency } from 'shared/helpers/IntlHelpers';
import { DottedLineRow } from 'shared/ui/DottedLine';

interface InstantTransferPriceInformationProps {
  price?: number | null;
  new_price?: number | null;
  fee_amount?: number | null;
  fee_percentage?: number | null;
}

export function InstantTransferPriceInformation({
  data: { price, new_price, fee_amount, fee_percentage },
  totalTitle = 'Paid Amount',
}: {
  data: InstantTransferPriceInformationProps;
  totalTitle?: string;
}) {
  const formattedPrice = formatCurrency(price, { minimumFractionDigits: 0 });

  const formattedNewPrice = formatCurrency(new_price, {
    minimumFractionDigits: 0,
  });

  const formattedFeePrice = formatCurrency(fee_amount, {
    minimumFractionDigits: 0,
  });

  return (
    <Stack space="small">
      <DottedLineRow
        variant="body2"
        title="Load Price"
        value={formattedPrice}
      />
      <DottedLineRow
        variant="body2"
        title={`Instant Transfer Fee (${fee_percentage || 0}%)`}
        value={formattedFeePrice}
      />
      <DottedLineRow
        title={totalTitle}
        value={formattedNewPrice}
        boldValue={true}
      />
    </Stack>
  );
}
